<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="jobName">Job</label>
                    <input id="jobName" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
